import React, { useEffect } from 'react';
import colors from '../../theme/colors';
import { Theme } from '../../theme/Theme';
import CommonButton from '../../components/common/CommonButton';

const AnErrorOccured = () => {
  useEffect(() => {
    const hadError = sessionStorage.getItem("serverError");
    if (!hadError) {
      const token = localStorage.getItem("token");
      const currentPath = window.location.pathname;
      if (currentPath === "/onboarding" || currentPath === "/verification-in-progress") {
        // Do not auto-redirect to prevent infinite redirect loops on client-side crashes
        return;
      }
      window.location.replace(token ? "/dashboard" : "/");
    } else {
      sessionStorage.removeItem("serverError");
    }
  }, []);

  return (
    <div 
      style={{
        height: '100vh',
        width: '100%',
        overflow: 'hidden',
        background: 'var(--bg-auth-container)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <div style={{ maxWidth: '900px', width: '100%', margin: '0 auto', padding: '0 16px' }}>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            textAlign: 'center',
          }}
        >
          <img
            src="/assets/images/404_error.svg"
            alt="An Error Occurred"
            style={{
              width: '100%',
              maxWidth: '100%',
              maxHeight: '50vh',
              height: 'auto',
              objectFit: 'contain',
              marginBottom: '32px',
              pointerEvents: 'none',
              mixBlendMode: 'multiply', // Blends the SVG's background into your gradient background
            }}
          />
          <h1 
            style={{ 
              ...Theme.font28SemiBold,
              // fontSize: 'clamp(2rem, 5vw, 3rem)',
              margin: '0 0 16px 0',
            }}
          >
            An Unexpected Error Occured
          </h1>
          <p 
            style={{ 
              ...Theme.font16Regular,
              marginBottom: '32px', 
              marginTop: 0,
              maxWidth: '600px',
              lineHeight: 1.6,
              color: colors.subTextColor,
            }}
          >
            Something went wrong while processing your request. Please try reloading the page or check back later!
          </p>
          <CommonButton
            title="Go Back"
            onClick={() => {
              const token = localStorage.getItem("token");
              const isNewBusinessUser = localStorage.getItem("isNewBusinessUser") === "true";
              const onboardingCompleted = localStorage.getItem("onboardingCompleted") === "true";
              if (token && isNewBusinessUser && !onboardingCompleted) {
                window.location.replace("/");
              } else {
                window.location.replace(token ? "/dashboard" : "/");
              }
            }}
            width="auto"
            style={{ padding: '0 48px', height: '48px', margin: 0 }}
          />
        </div>
      </div>
    </div>
  );
};

export default AnErrorOccured;
